import { getOperationName } from '@apollo/client/utilities'
import { useUpload } from '@web/react-common'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

import { GetBannersDocument, useAddBannerMutation, useFileCreateMutation } from '@/generated/graphql'

export const useBannerImageUpload = () => {
  const { t } = useTranslation()
  const [upload] = useFileCreateMutation()
  const [addBannerImage] = useAddBannerMutation({
    refetchQueries: [getOperationName(GetBannersDocument)!],
  })

  const { uploadClickRef } = useUpload(
    {
      upload: async (file) => {
        const { data } = await upload({
          variables: {
            file,
          },
        })
        return data!.fileCreate
      },
      onUploadStart() {},
      onUploadProgress() {},
      onUploadComplete(file) {
        addBannerImage({ variables: { fileId: file.fileId } })
      },
      onUploadError() {
        message.error(t('post.editor.uploadFailed'))
      },
    },
    []
  )

  return { uploadClickRef }
}
